import {on, emit} from './EventsBus';
import {CustomEvents} from './CustomEvents';

export const doAjax = options => {
  options = $.extend(
    true,
    {},
    {
      cache: false,
      async: true,
      type: 'GET'
    },
    options
  );
  return $.ajax(options);
};

export default class ajaxAction {

  static get SELECTORS() {
    return {
      source: '[data-ajax-source]',
      target: '[data-ajax-target]'
    };
  }

  constructor(classEl) {
    this.classEl = classEl;
  }

  // basics
  executeFunctionByName(functionName, context , args = false ) {
    var args = Array.prototype.slice.call(arguments, 2);
    var namespaces = functionName.split(".");
    var func = namespaces.pop();
    for(var i = 0; i < namespaces.length; i++) {
      context = context[namespaces[i]];
    }
    return context[func].apply(context, args);
  }

  updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if(uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  }

  // ajax function
  getPage(query) {
    // json configuration
    let ajaxConf = {
      type: 'GET',
      url: query,
    };
    return $.ajax(ajaxConf);
  }

  // content replacing function
  renderContent(res, contentname = false , fallbacks = false ) {
    // response
    const response = new DOMParser ().parseFromString(res, 'text/html');
    // update content
    let source = (contentname) ? response.querySelector('[data-ajax-source='+contentname+']') : response.querySelector(this.SELECTORS.source);
    let target = (contentname) ? document.querySelector('[data-ajax-target='+contentname+']') : document.querySelector(this.SELECTORS.target);
    if(typeof source !== 'undefined' && source != null && typeof target !== 'undefined' && target != null ) {
      // update the html
      target.innerHTML = source.innerHTML;
      emit(CustomEvents.AJAX_EVENTS.loaded);
      emit(CustomEvents.AJAX_EVENTS.updated);
    }
    //
    if(fallbacks && fallbacks.isArray()) {
      fallbacks.forEach(callback => {
        this.executeFunctionByName(callback, window);
      })
    }
    //
  }
}
